'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.ForschungsberichtSchema = {
  title: 'Forschungsbericht',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/forschungsbericht.js
// module id = ldwQ
// module chunks = 0